import React, { Component } from 'react'
import { post } from '../../utils/networking'
import { jsonFromUrlParam } from '../../utils'
import { configs } from '../../helpers/constants'
import Search from '../search'
import $ from 'jquery'
import { Route, NavLink, HashRouter, Router } from "react-router-dom";
import GoogleMapReact from 'google-map-react';
import { checkImage } from '../../checkImage'
import { ScaleLoader } from 'react-spinners'
import RatingReadOnly from 'react-rating'
import StarRatings from 'react-star-ratings'
import Map from 'react-js-google-maps'
import Pagination from '../../pagination'
import history from '../../redux/routerHistory'
import './style.css'

const Point = ({ text }) => (<div style={{ position: "relative", width: "100px", color: "#000", fontSize: "14px", fontWeight: "bold" }}>
    <i className="fa fa-map-marker" aria-hidden="true" style={{ fontSize: "40px", color: "red" }}></i>
</div>);



const _take = 10

export default class ListSpas extends Component {

    static defaultProps = {
        center: { lat: 59.95, lng: 30.33 },
        zoom: 11
    };



    constructor(props) {
        super(props)

        this.state = {
            spas: [],
            total: 0,
            showList: true,
            isLoaded: false,
            keyword: "",
            address: "",
            location: "",
            city: "",
            zipCode: 0,
            zoom: 15,
            page: 1,
            nextPage: 1
        }

        this.latitude = 0
        this.longtitude = 0

    }

    componentWillReceiveProps(nextProps) {
        this.search(nextProps.location.search);
    }
    componentDidMount() {
        this.search(this.props.location.search);
        window.addEventListener('scroll', () => {
            if (window.scrollY > 235 && ($('body')[0].offsetHeight - window.scrollY) > 900) {
                $("#ct_map").css('margin-top', (window.scrollY - 235).toString() + "px")
            }
        })
    }

    search(search) {
        if (search) {
            const searchParams = jsonFromUrlParam(search)
            this.setState({
                keyword: (searchParams.keyword) ? searchParams.keyword : "",
                location: (searchParams.location) ? searchParams.location : "",
                city: (searchParams.city) ? searchParams.city : "",
                zipCode: (searchParams.location) ? searchParams.location : ""
            }, () => {
                this.getSpas(0);
            })
        }


    }




    getSpas(skip) {

        const param = {
            keyword: this.state.keyword,
            location: this.state.location,
            skip: skip,
            take: _take,
            city: this.state.city,
            sortByNewest: true
        }
        let maxlng = 0, minlng = 0, maxlat = 0, minlat = 0;
        post('spa/search', param, "", result => {
            if (result.items.length > 0) {
                result.items.map((item, i) => {
                    let url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + item.address1.split(" ").join("%20") + '&key=AIzaSyDk17id-kgU2ZXd_LOq30TEsgsLAY45358';
                    fetch(url)
                        .then(res => res.json()
                            .then((out) => {
                                item.lng = out.results[0].geometry.location.lng;
                                item.lat = out.results[0].geometry.location.lat;
                                this.setState({
                                    spas: [...result.items],
                                    total: result.total,
                                    isLoaded: true
                                })
                            }))
                        .catch(err => { throw err });
                })
            } else {
                this.setState({
                    isLoaded: true
                })
            }
        }, error => {
            this.setState({
                isLoaded: true
            })
        })

    }


    loadMore() {
        this.getSpas(this.state.spas.length)
    }

    handleListClick(showList) {

        this.setState({ showList })
    }

    handlePageChange(page) {
        const skip = page * _take - _take;
        this.setState({
            page: page
        })
        this.getSpas(skip);
    }

    render() {
        $("html, body").animate({ scrollTop: 0 }, 400);
        let {
            spas,
            total,
            showList,
            isLoaded,
            address,
            page,
            nextPage
        } = this.state;

        let center = { lat: (spas.length > 0) ? spas[0].lat : 0, lng: (spas.length > 0) ? spas[0].lng : 0 }

        const setMarker = (map) => {

            if (spas.length > 0)
                spas.map((item, i) => {
                    const location = { lat: item.lat, lng: item.lng };
                    const marker = new window.google.maps.Marker({
                        position: location,
                        map: map
                    });

                    window.google.maps.event.addListener(marker, 'click', function () {
                        const infoWindow = new window.google.maps.InfoWindow({
                            content: "<b>" + item.name + "</b><div>" + item.address1 + "</div>"
                        });
                        infoWindow.open(map, marker);
                    })
                })
        };
        const mapOptions = {
            zoom: 10,
            center: { lat: (spas.length > 0) ? spas[0].lat : 0, lng: (spas.length > 0) ? spas[0].lng : 0 }
        }


        return (
            <div>
                <main>
                    <div id="map_wrapper">
                        <div id="map_canvas" className="mapping"></div>
                    </div>
                    <div className="border_line_bottom">
                        <div className="container">
                            {
                                (isLoaded) ?
                                    <div className="content clearfix page_spa">
                                        <div className="search-for-near">
                                            <form className="search-form icon_search_page" action="/spa">
                                                <div className="ct_search_page" style={{ paddingTop: "10px" }}>
                                                    <Search
                                                        initValue={this.state.address}
                                                        showSearchIcon={true}
                                                        longtitude={this.state.longtitude}
                                                        latitude={this.state.latitude}
                                                        keyword={(this.state.keyword) ? this.keyword : ""}
                                                        history={this.props.history}
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                        {
                                            (spas.length > 0) ? <div className="content_main clearfix">
                                                <div className="querytotalhitscount">
                                                    <p><span>{total}</span> Businesses Found <span className="totle_page">Page: {page}/{((total / _take) === parseInt(total / _take) ? parseInt(total / _take) : (parseInt(total / _take) + 1))}</span></p>
                                                </div>
                                                <div className="list_spa_map clearfix">
                                                    <div className="col_sm_4 list">
                                                        <p className={showList ? "active" : ""} onClick={(e) => this.handleListClick(true)}>LIST</p>
                                                    </div>
                                                    <div className="col_sm_4 map">
                                                        <p className={!showList ? "active" : ""} onClick={(e) => this.handleListClick(false)}>MAP</p>
                                                    </div>
                                                </div>
                                                <div className={showList ? "active left col_7 col_sm_12" : "left col_7 col_sm_12"}>
                                                    <div className="list_spa">
                                                        {spas.map((spa, i) =>

                                                            <div className={"top-spa-item"} key={i} >
                                                                <div className="item-detail">
                                                                    <NavLink to={"/spa/" + ((spa.slug) ? spa.slug : "")} ><div className="detail-left-image" style={{ background: "url(" + ((spa.photo) ? ("http://pos.nailspaofamerica.com/ClientWeb/FileUpload/" + spa.photo) : "http://binhphuoc.gov.vn/themes/default/images/businesslistings/noimages.png") + ")" }} ></div></NavLink>
                                                                    <div className="detail-right">
                                                                        <NavLink to={"/spa/" + spa.slug} ><span className="spa-name">{spa.name}</span></NavLink>
                                                                        <div className="rating-review">
                                                                            <StarRatings
                                                                                rating={spa.rate}
                                                                                starRatedColor="#935ed6"
                                                                                numberOfStars={5}
                                                                                starSpacing="9px"
                                                                                starEmptyColor="#e3ceff"
                                                                            />
                                                                            <span className="review-count">{spa.reviews} Reviews</span>
                                                                        </div>
                                                                        <span className="spa-address">{spa.address1}</span>
                                                                        {
                                                                            (spa.latestReview) ? <div className="lastest-review">
                                                                                <div className="left">
                                                                                    <span className="name">Review by:<br />{(spa.latestReview) ? spa.latestReview.reviewerName : ""}</span>
                                                                                </div>
                                                                                <div className="right">
                                                                                    <span className="title">{(spa.latestReview) ? spa.latestReview.title : ""}</span>
                                                                                    <RatingReadOnly
                                                                                        color="red"
                                                                                        initialRating={(spa.latestReview) ? spa.latestReview.overallRating : ""}
                                                                                        emptySymbol={<img src={require('../../assets/images/star_empty.png')} className="icon" style={{ width: "15px", marginRight: "2px" }} />}
                                                                                        fullSymbol={<img src={require('../../assets/images/star.png')} className="icon" style={{ width: "15px", marginRight: "2px" }} />}
                                                                                        readonly
                                                                                    />
                                                                                    <span className="decription">{(spa.latestReview) ? spa.latestReview.description.substring(0, 60) : ""}</span>
                                                                                    <span className="see-more"><NavLink to={"spa/" + ((spa.slug) ? spa.slug : "")}>Read more...</NavLink></span>
                                                                                </div>
                                                                            </div> : <div className="lastest-review">
                                                                                    <div className="left">
                                                                                        <span className="name">No review</span>
                                                                                    </div>
                                                                                    <div className="right">
                                                                                    </div>
                                                                                </div>
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <Pagination
                                                        total={total}
                                                        pageSize={_take}
                                                        currentPage={page}
                                                        onPageChange={this.handlePageChange.bind(this)}
                                                    />
                                                </div>
                                                <div className={!showList ? "active right col_5 col_sm_12" : "right col_5 col_sm_12"}>
                                                    <div className="row_col">
                                                        <div className="google_map">
                                                            <div id="ct_map" className="ct_map">
                                                                <Map
                                                                    id="map1"
                                                                    apiKey="AIzaSyDnZHCNVuYH8lZSMZtuHzJ4677eUi6AE8w"
                                                                    mapOptions={mapOptions}
                                                                    style={{ width: 500, height: 300, float: "left" }}
                                                                    onLoad={setMarker}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> : <span className="search_not_found">Not Found</span>
                                        }
                                    </div> :
                                    <div style={{ width: "100%", height: "100vh", textAlign: "center", paddingTop: "40vh" }}>
                                        <ScaleLoader
                                            color={'#935ed6'}
                                            loading={true}
                                            width={10}
                                            height={60}
                                            margin="1px"
                                            radius={0}
                                        />
                                    </div>
                            }
                        </div>
                    </div>
                </main>
            </div >
        )

    }
}




// WEBPACK FOOTER //
// ./src/components/listSpas/index.js